// The onboarding tour script. `target`, `enter`, and `leave` may be functions
// of (controls, isMobile) so a step can adapt to the platform and drive app
// state (open a menu / drawer / switch tab) before its target is measured.
// `platform: "mobile" | "desktop"` scopes a step to one layout; default = both.
// See ONBOARDING-DESIGN.md. Phase 2 covers the Practice area + its two menus;
// the cross-tab steps (Review/Friends/Leaderboard/privacy) are Phase 3.
export const TOUR_STEPS = [
  {
    id: "welcome",
    target: null,
    title: "Welcome to Better Your Blackjack",
    body: "Practice card counting against a real blackjack engine, then compete on the leaderboard. This quick tour shows you around, it takes about a minute, and you can skip anytime.",
  },

  {
    id: "menus",
    target: (m) => (m ? '[data-tour="shell-menu"]' : '[data-tour="nav-tabs"]'),
    enter: (c, m) => m && c.shell?.openMenu?.(),
    leave: (c, m) => m && c.shell?.closeMenu?.(),
    title: "Getting around",
    body: "Switch between Practice, Review, Friends, Leaderboard, and your account from here.",
  },

  {
    id: "trainer-tools",
    target: (m) =>
      m ? '[data-tour="trainer-menu"]' : '[data-tour="trainer-toolbar"]',
    enter: (c, m) => m && c.trainer?.openMenu?.(),
    leave: (c, m) => m && c.trainer?.closeMenu?.(),
    title: "Your table tools",
    body: "Table Rules, Strategy & Glossary, the Shoe log, and Live Coaching all live here.",
  },

  {
    id: "count",
    target: '[data-tour="count-tools"]',
    title: "Keep the count",
    body: "As cards come out, keep a running count in your head. Type your guess and Check yourself here. Reveal shows the true count, handy for learning, but it marks the shoe as count-aided.",
  },

  {
    id: "bet",
    target: '[data-tour="deal-btn"]',
    title: "Bet & deal",
    body: "Set your bet with the chips, then Deal. Raise your bet as the count climbs, betting more when the deck favors you is how counting actually pays off.",
  },

  {
    id: "learn",
    platform: "desktop",
    target: '[data-tour="learn-menu"]',
    enter: (c) => c.trainer?.openLearn?.(),
    leave: (c) => c.trainer?.closeLearn?.(),
    title: "Strategy & Glossary",
    body: "Unsure of a play or a term? Basic strategy charts and a plain-language glossary live under Learn.",
  },

  {
    id: "coaching",
    platform: "desktop",
    target: '[data-tour="lc-pill"]',
    title: "Live Coaching",
    body: "Want the correct move shown before you act? Toggle Live Coaching, but it makes a shoe leaderboard-ineligible.",
  },

  {
    id: "ranked",
    target: '[data-tour="ranked-toggle"]',
    enter: (c) => c.trainer?.openDrawer?.("rules"),
    leave: (c) => c.trainer?.closeDrawers?.(),
    title: "Ranked mode",
    body: "In Rules, Ranked mode locks the official rules, hides the count, and prompts you to submit it ~5× a shoe. These are the shoes that count for the leaderboard.",
  },

  {
    id: "gate",
    target: null,
    gate: true,
    title: "Want the full tour?",
    body: "You've got everything you need to play. The rest covers Review, Friends, the Leaderboard, and privacy — take it now or skip straight to playing.",
  },

  {
    id: "review",
    target: '[data-tour="review-head"]',
    enter: (c) => c.shell?.setTab?.("Review"),
    title: "Review your shoes",
    body: "Every shoe you play is saved here with its accuracy and net, tagged verified and ranked once the server checks it.",
  },

  {
    id: "friends",
    target: '[data-tour="friend-tabs"]',
    enter: (c) => c.shell?.setTab?.("Friends"),
    title: "Friends",
    body: "Add players by username to compare validated stats and line up against each other on the friends leaderboard.",
  },

  {
    id: "leaderboard",
    target: '[data-tour="lb-controls"]',
    enter: (c) => c.shell?.setTab?.("Leaderboard"),
    title: "The leaderboard",
    body: "Three boards — Counting, Betting, EV — global or just friends, this season or all-time. Ranked shoes are what land you here.",
  },

  {
    id: "privacy",
    target: '[data-tour="leaderboard-opt-in"]',
    enter: (c) => c.shell?.gotoAccount?.(),
    leave: (c) => c.shell?.gotoApp?.(),
    title: "Your privacy",
    body: "You're on the global leaderboard by default. Opt out anytime from this toggle under Account → Privacy.",
  },

  {
    id: "finish",
    target: null,
    enter: (c) => c.shell?.setTab?.("Practice"),
    title: "You're set",
    body: "That's the full tour. Play a few Ranked shoes to land on the board. You can replay this anytime from the Glossary's “Take the tour.”",
  },
];
